import React from 'react';


export default function Post_View() {
  return <h2>Post View</h2>;
}
